export type MessageType = 'chatroom_user_joined' | 'chatroom_user_left' | 'message' | 'status' | 'chatroom_archived';

export const MessageReadText = 'read';

export type MessageTypeForPreview = 'attachment' | 'empty' | 'text';
